import { render, staticRenderFns } from "./ReturnChargesFile.vue?vue&type=template&id=c0db9d22&scoped=true"
import script from "./ReturnChargesFile.vue?vue&type=script&lang=js"
export * from "./ReturnChargesFile.vue?vue&type=script&lang=js"
import style0 from "./ReturnChargesFile.vue?vue&type=style&index=0&id=c0db9d22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0db9d22",
  null
  
)

export default component.exports